riot.tag2('gb-select-button', '<yield> <span class="gb-button__label">{_scope.selectLabel()}</span> <img riot-src="{_scope.iconUrl}" alt=""> </yield>', 'gb-select-button img,[riot-tag="gb-select-button"] img,[data-is="gb-select-button"] img{ margin-left: 10px; margin-top: 2px; height: 24px; }', '', function(opts) {
    this.root.addEventListener('focus', this._scope.prepFocus);
    this.root.addEventListener('click', this._scope.unFocus);
});



/** WEBPACK FOOTER **
 ** ./src/tags/select/gb-select-button.tag.html
 **/